import * as React from "react"
import { cn } from "@/lib/utils"

function PageHeader({ title, description, actions, className, ...props }) {
  return (
    <header
      className={cn("flex flex-col gap-4 pb-6 md:flex-row md:items-end md:justify-between", className)}
      {...props}>
      <div className="space-y-1">
        <h1 className="font-display text-page-title text-ink">{title}</h1>
        {description && <p className="text-small text-ink-muted">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </header>
  )
}

export { PageHeader }
